// "Start from an Otable document": the file part of the new publication / proposal dialogs (otableFile.js).
import React, { useRef } from 'react';
import { Alert, Box, Button, CircularProgress, Divider, Typography } from '@mui/material';
import { UploadFile as UploadIcon } from '@mui/icons-material';
import { OTABLE_ACCEPT } from './otableFile';

export default function OtableFileStart({ kind = 'publication', busy, error, onFile }) {
  const input = useRef(null);
  return (
    <Box sx={{ mt: 3 }}>
      <Divider sx={{ mb: 2 }}><Typography variant="caption" color="text.secondary">or</Typography></Divider>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        <Button variant="outlined" startIcon={busy ? <CircularProgress size={16} /> : <UploadIcon />} disabled={busy}
          onClick={() => input.current?.click()}>
          {busy ? 'Importing…' : `Start from an Otable document (.otable)`}
        </Button>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 220 }}>
          A {kind} you exported from Otable — its sections, figures, references, authors and comments come with it.
        </Typography>
      </Box>
      {error && <Alert severity="error" sx={{ mt: 1.5 }}>{error}</Alert>}
      <input ref={input} type="file" hidden accept={OTABLE_ACCEPT}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; if (f) onFile(f); }} />
    </Box>
  );
}
